import axios from 'src/utils/axios';
import { COLORS } from '../global/constants';

export const GET_BOARD = '@kanban/get-board';
export const CREATE_LIST = '@kanban/create-list';
export const UPDATE_LIST = '@kanban/update-list';
export const CLEAR_LIST = '@kanban/clear-list';
export const DELETE_LIST = '@kanban/delete-list';
export const CREATE_CARD = '@kanban/create-card';
export const UPDATE_CARD = '@kanban/update-card';
export const MOVE_CARD = '@kanban/move-card';
export const DELETE_CARD = '@kanban/delete-card';
export const ADD_COMMENT = '@kanban/add-comment';
export const ADD_CHECKLIST = '@kanban/add-checklist';
export const UPDATE_CHECKLIST = '@kanban/update-checklist';
export const DELETE_CHECKLIST = '@kanban/delete-checklist';
export const ADD_CHECK_ITEM = '@kanban/add-check-item';
export const UPDATE_CHECK_ITEM = '@kanban/update-check-item';
export const DELETE_CHECK_ITEM = '@kanban/delete-check-item';
export const ADD_USER_CARD = '@kanban/add-user-card';
export const REMOVE_USER_CARD = '@kanban/remove-user-card';

const cardColors = [];
const colors = [...COLORS];

function getLabelColor(task) {
  const found = cardColors.find(
    color =>
      color.order === task.CodigoOrdemServico && color.item === task.CodigoItem
  );

  if (found) {
    return found.color;
  }

  const background = {
    backgroundColor: colors[0],
  };

  cardColors.push({
    order: task.CodigoOrdemServico,
    item: task.CodigoItem,
    color: background,
  });

  colors.splice(0, 1);

  return background;
}

function addCards(phase) {
  const cards = [];

  phase.Tarefas.forEach(task => {
    cards.push({
      id: `task_${task.Codigo}`,
      taskId: task.Codigo,
      attachments: [],
      checklists: [],
      comments: [],
      cover: null,
      description: `Tempo previsto: ${task.TempoPrevisto}`,
      expectedTime: task.TempoPrevisto,
      due: null,
      isSubscribed: false,
      listId: parseInt(phase.Codigo, 10),
      memberIds: task.TecnicosTarefa.map(a => a.CodigoTecnico),
      name: `${task.Sequencia} - ${task.Descricao}`,
      serviceOrderCode: task.CodigoOrdemServico,
      itemCode: task.CodigoItem,
      cardColor: getLabelColor(task),
      expectedDate: {
        initial: task.PrevistoInicial,
        final: task.PrevistoFinal,
      },
      date: {
        initial: task.DataInicial,
        final: task.DataFinal,
      },
      orderItem: {
        businessValue: task.SprintItemOrdemServico.ValorNegocio,
      },
    });
  });

  return cards;
}

function proccessBoard(data) {
  const kanban = {
    board: {
      lists: [],
      cards: [],
      members: [],
    },
  };

  data.TemplateKanban.Fases.forEach(phase => {
    const hasChildren = data.TemplateKanban.Fases.some(element => {
      return element.CodigoFasePai === phase.Codigo;
    });

    let description = phase.Descricao;

    if (phase.CodigoFasePai !== 0) {
      const father = data.TemplateKanban.Fases.find(
        // Verificar com Dalmora alteração que fizeram na API que mudaram só um para string, o outro ficou number
        // eslint-disable-next-line eqeqeq
        element => element.Codigo == phase.CodigoFasePai
      );

      description = `${father?.Descricao ?? ''} - ${description}`;
    }

    const cards = addCards(phase);

    if (!hasChildren) {
      kanban.board.lists.push({
        id: parseInt(phase.Codigo, 10),
        name: description,
        cardIds: cards.map(tarefa => tarefa.id),
        backgroundColor: phase.CorHexadecimal || '#5C6BC0',
        order: phase.Ordem,
      });
    }

    kanban.board.cards = [...kanban.board.cards, ...cards];
  });

  kanban.board.members = data.TecnicosSprint.filter(
    technician => technician.Tecnico !== null
  ).map(technician => ({
    id: technician.Tecnico.Empresa,
    name: technician.Tecnico.Nome,
    avatar: null,
  }));

  return kanban;
}

export function getBoard(match) {
  const { sprint } = match.params;
  const request = axios.get(`/servicos/gs/sprints/estruturakanban/${sprint}`);

  return dispatch => {
    request.then(response => {
      const board = proccessBoard(response.data);
      dispatch({
        type: GET_BOARD,
        payload: board,
      });
    });
  };
}

export function setBoard(kanban) {
  return dispatch => {
    const board = proccessBoard(JSON.parse(kanban));
    dispatch({
      type: GET_BOARD,
      payload: board,
    });
  };
}

export function addUserCard(cardId, userId) {
  const split = cardId.split('_');
  const request = axios.post('/servicos/gs/tecnicostarefakanban', {
    CodigoTecnico: userId,
    CodigoTarefa: split[1],
  });

  const userIdCard = {
    cardId,
    userId,
  };

  return dispatch => {
    request.then(() => {
      dispatch({
        type: ADD_USER_CARD,
        payload: userIdCard,
      });
    });
  };
}

export function removeUserCard(cardId, userId) {
  const split = cardId.split('_');
  const request = axios.delete('/servicos/gs/tecnicostarefakanban', {
    data: {
      CodigoTecnico: userId,
      CodigoTarefa: split[1],
    },
  });

  const userIdCard = {
    cardId,
    userId,
  };

  return dispatch => {
    request.then(() => {
      dispatch({
        type: REMOVE_USER_CARD,
        payload: userIdCard,
      });
    });
  };
}

export function createList(name) {
  const request = axios.post('/api/kanban/board/lists/new', {
    name,
  });

  return dispatch => {
    request.then(response =>
      dispatch({
        type: CREATE_LIST,
        payload: response.data,
      })
    );
  };
}

export function updateList(listId, update) {
  const request = axios.post('/api/kanban/board/list/update', {
    listId,
    update,
  });

  return dispatch => {
    request.then(response =>
      dispatch({
        type: UPDATE_LIST,
        payload: response.data,
      })
    );
  };
}

export function clearList(listId) {
  const request = axios.post('/api/kanban/board/lists/clear', {
    listId,
  });

  return dispatch => {
    request.then(() =>
      dispatch({
        type: CLEAR_LIST,
        payload: {
          listId,
        },
      })
    );
  };
}

export function deleteList(listId) {
  const request = axios.post('/api/kanban/board/lists/remove', {
    listId,
  });

  return dispatch => {
    request.then(() =>
      dispatch({
        type: DELETE_LIST,
        payload: {
          listId,
        },
      })
    );
  };
}

export function createCard(listId, name) {
  const request = axios.post('/api/kanban/board/cards/new', {
    listId,
    name,
  });

  return dispatch => {
    request.then(response =>
      dispatch({
        type: CREATE_CARD,
        payload: response.data,
      })
    );
  };
}

export function updateCard(cardId, update) {
  const request = axios.post('/api/kanban/board/cards/update', {
    cardId,
    update,
  });

  return dispatch => {
    request.then(response =>
      dispatch({
        type: UPDATE_CARD,
        payload: response.data,
      })
    );
  };
}

export function moveCard(cardId, position, listId, source, request) {
  return dispatch => {
    dispatch({
      type: MOVE_CARD,
      payload: {
        cardId,
        position,
        listId,
      },
    });

    request.catch(() => {
      dispatch({
        type: MOVE_CARD,
        payload: {
          cardId,
          position: source.index,
          listId: source.droppableId,
        },
      });
    });
  };
}

export function deleteCard(cardId) {
  const request = axios.post('/api/kanban/board/cards/remove', {
    cardId,
  });

  return dispatch => {
    request.then(() =>
      dispatch({
        type: DELETE_CARD,
        payload: {
          cardId,
        },
      })
    );
  };
}

export function addComment(userId, cardId, message) {
  const request = axios.post('/api/kanban/board/cards/comments', {
    userId,
    cardId,
    message,
  });

  return dispatch => {
    request.then(response =>
      dispatch({
        type: ADD_COMMENT,
        payload: response.data,
      })
    );
  };
}

export function addChecklist(cardId, name) {
  const request = axios.post('/api/kanban/board/checklists/new', {
    cardId,
    name,
  });

  return dispatch => {
    request.then(response =>
      dispatch({
        type: ADD_CHECKLIST,
        payload: {
          cardId,
          ...response.data,
        },
      })
    );
  };
}

export function updateChecklist(cardId, checklistId, update) {
  const request = axios.post('/api/kanban/board/checklists/update', {
    cardId,
    checklistId,
    update,
  });

  return dispatch => {
    request.then(response =>
      dispatch({
        type: UPDATE_CHECKLIST,
        payload: {
          cardId,
          checklistId,
          ...response.data,
        },
      })
    );
  };
}

export function deleteChecklist(cardId, checklistId) {
  const request = axios.post('/api/kanban/board/checklists/remove', {
    cardId,
    checklistId,
  });

  return dispatch => {
    request.then(() =>
      dispatch({
        type: DELETE_CHECKLIST,
        payload: {
          cardId,
          checklistId,
        },
      })
    );
  };
}

export function addCheckItem(cardId, checklistId, name) {
  const request = axios.post('/api/kanban/board/checkitems/new', {
    cardId,
    checklistId,
    name,
  });

  return dispatch => {
    request.then(response =>
      dispatch({
        type: ADD_CHECK_ITEM,
        payload: {
          cardId,
          checklistId,
          ...response.data,
        },
      })
    );
  };
}

export function updateCheckItem(cardId, checklistId, checkItemId, update) {
  const request = axios.post('/api/kanban/board/checkitems/update', {
    cardId,
    checklistId,
    checkItemId,
    update,
  });

  return dispatch => {
    request.then(response =>
      dispatch({
        type: UPDATE_CHECK_ITEM,
        payload: {
          cardId,
          checklistId,
          checkItemId,
          ...response.data,
        },
      })
    );
  };
}

export function deleteCheckItem(cardId, checklistId, checkItemId) {
  const request = axios.post('/api/kanban/board/checkitems/remove', {
    cardId,
    checklistId,
    checkItemId,
  });

  return dispatch => {
    request.then(() =>
      dispatch({
        type: DELETE_CHECK_ITEM,
        payload: {
          cardId,
          checklistId,
          checkItemId,
        },
      })
    );
  };
}
